import type { FaireBrandEntity } from "../../entity_types/brand";

export const williamsburgHome: FaireBrandEntity = {
  token: "williamsburg-home",
  type: "brand",
  name: "Williamsburg Home",
  description: "Curated home goods and accessories",
  rating: 4.6,
  location: "Williamsburg, NY",
  minimumOrderDollars: 250,
  tags: ["home", "curated", "design"],
  categoryTokens: ["cat_accessories"],
  meta: {
    source: "mock",
    importedAt: "2026-03-24T00:00:00.000Z",
    importedBy: "entity-db-bootstrap",
  },
};
